const html = require('choo/html');
const Component = require('choo/component');
const Account = require('./account');
const assets = require('../../common/assets');
const { platform } = require('../utils');
const { isDark, toggleTheme } = require('../theme');

class Header extends Component {
  constructor(name, state, emit) {
    super(name);
    this.state = state;
    this.emit = emit;
    this.account = state.cache(Account, 'account');
  }

  update() {
    this.account.render();
    return false;
  }
  toggleTheme(event) {
    event.preventDefault();
    const dark = toggleTheme();
    event.currentTarget.setAttribute('aria-pressed', String(dark));
  }

  createElement() {
    const logo = html`
      <span class="flex flex-row items-center">
        <img
          class="logo dark:hidden"
          alt="Talan"
          src="${assets.get('talan-logo.png')}"
        />
        <img
          class="logo hidden dark:block"
          alt="Talan"
          src="${assets.get('talan-logo-white.png')}"
        />
        <span
          class="ml-3 pl-3 border-l-2 border-orange-50 text-xl md:text-2xl font-bold leading-none text-blue-60 dark:text-white"
        >
          ${this.state.translate('title')}
        </span>
      </span>
    `;
    const title =
      platform() === 'android'
        ? html`
            <a class="flex flex-row items-center">${logo}</a>
          `
        : html`
            <a class="flex flex-row items-center" href="/">${logo}</a>
          `;
    const dark = typeof document !== 'undefined' && isDark();
    const label = this.state.translate('themeToggle');
    return html`
      <header
        class="main-header relative flex-none flex flex-row items-center justify-between w-full px-6 md:px-8 h-16 md:h-24 z-20 bg-transparent"
      >
        ${title}
        <div class="flex flex-row items-center">
          <button
            class="theme-toggle flex items-center justify-center w-10 h-10 rounded-full text-blue-60 hover:bg-grey-20 dark:text-orange-40 dark:hover:bg-grey-80 focus:outline"
            title="${label}"
            aria-label="${label}"
            aria-pressed="${String(dark)}"
            onclick="${e => this.toggleTheme(e)}"
          >
            <svg
              class="w-6 h-6 dark:hidden"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
            <svg
              class="w-6 h-6 hidden dark:block"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="5" />
              <path
                d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
              />
            </svg>
          </button>
          ${this.account.render()}
        </div>
      </header>
    `;
  }
}

module.exports = Header;
